import { type ReactNode } from 'react'

export const PageLayoutHeader = ({ header }: { header?: ReactNode }) => {
  if (!header) return null

  return <div className="w-full">{header}</div>
}
